/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Box, Center, Container, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { getFilterTitle, getYear } from '../../utils.js';
import { mappingKhmerNumber } from '../../../../utils/market-development.js';
import Company from '../../../../components/Company.js';
import PrintLayout from '../../../../components/Print/PrintLayout.js';
import BreadcrumbComponent from '../../../../components/BreadcrumbComponent/BreadcrumbComponent.js';
import InvestmentReportSpreadSheetTable from './InvestmentReportSpreadSheetTable.js';
import Filter from '../ews-summary-filter.js';
import useStore from '../../../../store/index.js';
import c from '../../../../constant.js';
import ExportExcelSummarizedReportIR from '../../../../components/EarlyWarning/SummarizedReport/ExcelSummarizedReportIR.js';

function SummarizedInvestmentReport() {
	const location = useLocation();
	const history = useHistory();
	const urlParams = new URLSearchParams(location.search);
	const period = urlParams.get('period') || null;
	const reportId = urlParams.get('reportId') || null;
	const report = urlParams.get('report') || null;
	const year = urlParams.get('year') || null;
	const [month, setMonth] = useState(null);
	const companyType = urlParams.get('companyType') || null;
	const companyId = urlParams.get('companyId') || null;
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [breadcrumb, setBreadcrumb] = useState([]);
	const [exportIR, setExportIR] = useState(null);

	useEffect(() => {
		if (period && reportId) {
			setBreadcrumb([
				{
					name: 'Company Report',
					path: '/company-submission-report',
				},
				{
					name: period,
					path: `/early-warning-system?period=${period}&reportId=${reportId}&page=1&report=${report}`,
				},
				{
					name: 'Summarized Investment Report',
					path: '#',
				},
			]);
		} else {
			setBreadcrumb([
				{
					name: 'Company Report',
					path: '/company-submission-report',
				},
				{
					name: 'Summarized Investment Report',
					path: '#',
				},
			]);
		}
	}, [period, reportId]);

	return (
		<PrintLayout>
			<Container maxW="container.xl" mt="16px" mb="16px">
				<BreadcrumbComponent list={breadcrumb} />
				<Center mt="5">
					<Box
						w="100%"
						bg="white"
						borderRadius={c.borderRadius}
						border="1px solid #dbdbdb"
						boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
						pb="32px"
					>
						<Flex
							className="hidden-print"
							bg="#FAFAFA"
							p="16px"
							pt="8px"
							pb="8px"
							mb="0px"
							alignItems="center"
							justifyContent="space-between"
							borderBottom="1px solid #dbdbdb"
						>
							<Text fontSize="x-large" fontWeight="bold">
								{t('Summarized Investment Report')}
							</Text>
							<Flex>
								<ExportExcelSummarizedReportIR month={month} year={year} object={exportIR} mr={2} />
								<Filter
									period={period}
									reportId={reportId}
									report={report}
									year={year}
									companyId={companyId}
									companyType={companyType}
									onCallback={(url) => history.push(`/early-warning-system/summarized-ir-report${url}`)}
								/>
							</Flex>
						</Flex>
						<Flex flexDirection="column" justifyContent="center" alignItems="center" pt={4} pl={4} pr={4} pb={1}>
							<Text fontSize="xl" fontWeight="700" color="blue.500" mb={1}>
								{t(getFilterTitle(companyType))}
							</Text>
							{companyId && (
								<Box mb={1}>
									<Company id={companyId} color="blue.500" />
								</Box>
							)}
							<Text fontSize="xl" fontWeight="700" color="blue.500">
								{lang === 'kh' ? mappingKhmerNumber(getYear(year)) : getYear(year)}
							</Text>
						</Flex>
						<Box pt={2} pl={4} pr={4}>
							<InvestmentReportSpreadSheetTable
								year={year}
								companyType={companyType}
								companyId={companyId}
								onReadyForExport={(result) => setExportIR(result)}
							/>
						</Box>
					</Box>
				</Center>
			</Container>
		</PrintLayout>
	);
}

export default SummarizedInvestmentReport;
